import React from 'react';
import { NavLink } from 'react-router-dom';

const AddSectorCrumb = () => <NavLink to="/admin/sectors/add">Add Sector</NavLink>;

export default AddSectorCrumb;
